<template>
  <section class="schedule-day">
    <div v-if="scheduleTypes.length > 1" class="schedule-type">
      <button
        v-for="item in scheduleTypes"
        :key="`schedule-type-${item.type}`"
        type="button"
        class="change_class_icon"
        :class="{ hidden: Number(scheduleType) === Number(item.type) }"
        @click="$emit('change-schedule-type', item.type)"
      >
        <span class="material-icons">{{ item.icon }}</span>
      </button>
    </div>

    <div v-if="loading" class="schedule-day__loading" />

    <EmptyStateNotice
      v-else-if="!lessons.length"
      :text="t('scheduleEmpty')"
      variant="info"
    />

    <div v-else class="day-schedule">
      <div v-for="(item, index) in lessons" :key="`day-lesson-${index}`" class="lesson">
        <div class="item">
          <div class="left big-number">{{ item.key }}</div>
          <div class="lessons__name">
            <template
              v-for="(lessonName, lessonIndex) in Array.isArray(item.value?.lesson)
                ? item.value.lesson
                : []"
              :key="`name-${index}-${lessonIndex}`"
            >
              <div
                class="lesson-subject defaultDay"
                :class="[
                  getLessonClass(lessonName),
                  { 'lesson-subject--clickable': isLessonNavigable(lessonName) },
                ]"
                @click="onLessonClick(lessonName)"
              >
                <div class="d-flex flex-row">
                  <div class="lesson-subject__title">
                    {{ resolveSubjectByLang(lessonName?.subject, lang) }}
                    <span
                      v-if="Number(lessonName?.training_type || 0) === 11"
                      class="small weigth-600 duty"
                    >
                      ({{ t("dutyClass") }})
                    </span>
                  </div>
                  <div
                    v-if="Array.isArray(lessonName?.mark) && lessonName.mark.length"
                    class="lesson-marks"
                  >
                    <span
                      v-for="(mark, markIndex) in lessonName.mark"
                      :key="`mark-${index}-${lessonIndex}-${markIndex}`"
                      class="mark__body"
                      :class="getColorClassByMark(mark)"
                    >
                      <span
                        class="mb-1 text-pink mr-1"
                        v-if="Number(mark?.m_id || 0) === 103"
                      >
                        <img :src="trophy" alt="" />
                      </span>
                      <span class="green mr-1" v-else>
                        <img :src="badge" alt="" />
                      </span>
                      {{ Number(mark?.ball) >= 0 ? mark.ball : mark?.mark_value }}
                      <template v-if="Number(mark?.m_id || 0) === 103">
                        / {{ Number(mark?.so_ball || mark?.lplan?.so_ball || 0) }}
                      </template>
                      <template v-else-if="Number(mark?.m_id || 0) === 105">
                        / 10
                      </template>
                    </span>
                  </div>
                </div>
                <div class="clock-lesson">
                  <i class="far fa-clock text-success"></i>
                  <span class="lesson__time">
                    {{ lessonName?.time_start }} - {{ lessonName?.time_end }}
                  </span>
                </div>

                <template v-if="Array.isArray(lessonName?.lplans)">
                  <div
                    v-for="(plan, planIndex) in lessonName.lplans"
                    :key="`plan-${index}-${lessonIndex}-${planIndex}`"
                    class="item d-flex flex-column"
                  >
                    <div v-if="plan?.theme_name" class="lesson__text">
                      <span
                        v-if="
                          Number(plan?.lesson_view || 0) === 21 ||
                          Number(plan?.lesson_view || 0) === 22 ||
                          Number(plan?.lesson_view || 0) === 33
                        "
                        class="material-icons mr-2 schedule-plan-icon text-pink"
                      >
                        star
                      </span>
                      <span
                        v-else-if="Number(lessonName?.training_type || 0) === 10"
                        class="material-icons mr-2 schedule-plan-icon text-pink"
                      >
                        record_voice_over
                      </span>
                      <span
                        v-else-if="Number(lessonName?.training_type || 0) === 3"
                        class="material-icons mr-2 schedule-plan-icon text-purple"
                      >
                        menu_book
                      </span>
                      <span
                        v-else
                        class="material-icons mr-2 schedule-plan-icon text-purple"
                        >bookmark</span
                      >
                      {{ plan.theme_name }}
                    </div>
                    <div
                      v-if="plan?.hometask"
                      class="lesson__text"
                      v-html="withIcon('home', plan.hometask)"
                    ></div>
                    <div
                      v-if="plan?.goal"
                      class="lesson__text"
                      v-html="withIcon('flag', plan.goal)"
                    ></div>
                    <div
                      v-if="plan?.tasks"
                      class="lesson__text"
                      v-html="withIcon('add_task', plan.tasks)"
                    ></div>
                  </div>
                </template>

                <template v-if="Array.isArray(lessonName?.mark)">
                  <div
                    v-for="(mark, markCommentIndex) in lessonName.mark"
                    :key="`comment-${index}-${lessonIndex}-${markCommentIndex}`"
                    class="comment__body"
                  >
                    <span
                      v-if="mark?.comment"
                      class="material-icons comment__icons mr-2 f-14"
                      >forum</span
                    >
                    <span v-if="mark?.comment">{{ mark.comment }}</span>
                  </div>
                </template>

                <div
                  v-if="Array.isArray(lessonName?.endDate) && lessonName.endDate.length"
                  class="endDateClass"
                >
                  <div
                    v-for="(deadline, deadlineIndex) in lessonName.endDate"
                    :key="`deadline-${index}-${lessonIndex}-${deadlineIndex}`"
                    class="d-flex align-items-center"
                  >
                    <template v-if="isDeadlineVisible(deadline)">
                      <span
                        class="circuleEndDate material-icons"
                        :class="deadlineColor(deadline?.endDate)"
                      >
                        lens
                      </span>
                      <div class="d-flex align-items-center">
                        <template v-if="deadlineState(deadline?.endDate).active">
                          {{ deadlineState(deadline?.endDate).text }}
                          <span
                            class="deadline-time ml-2"
                            :class="deadlineState(deadline?.endDate).borderClass"
                          >
                            {{ deadlineState(deadline?.endDate).time }}
                          </span>
                        </template>
                        <template v-else>
                          {{ t("timeEndPassTask") }}
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div v-if="getNextStartTime(index)" class="resttime">
          <span v-if="pauseBetween(index) > 0">
            {{ breakText[0] }}
            {{ pauseBetween(index) }}
            {{ breakText[1] }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from "vue-i18n";

import badgeIcon from "@/assets/badge.svg";
import EmptyStateNotice from "@/components/common/EmptyStateNotice.vue";
import trophyIcon from "@/assets/trophy.svg";
import {
  getColorClassByMark,
  getPauseTime,
  resolveSubjectByLang,
} from "@/utils/schedule";

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  dayItem: {
    type: Object,
    default: null,
  },
  lessons: {
    type: Array,
    default: () => [],
  },
  lang: {
    type: String,
    default: "ru",
  },
  scheduleTypes: {
    type: Array,
    default: () => [],
  },
  scheduleType: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(["change-schedule-type", "open-lesson"]);

const { t, tm } = useI18n();
const breakText = tm("break_text");

function firstLesson(item) {
  if (!item?.value?.lesson || !Array.isArray(item.value.lesson)) return null;
  return item.value.lesson[0] || null;
}

function getCurrentEndTime(index) {
  const current = props.lessons[index];
  return firstLesson(current)?.time_end || "";
}

function getNextStartTime(index) {
  const next = props.lessons[index + 1];
  return firstLesson(next)?.time_start || "";
}

function pauseBetween(index) {
  return getPauseTime(getCurrentEndTime(index), getNextStartTime(index));
}

function getLessonClass(lesson) {
  if (!lesson || !Array.isArray(lesson.lplans)) return "";
  let result = -1;
  for (let i = 0; i < lesson.lplans.length; i += 1) {
    const plan = lesson.lplans[i];
    const view = Number(plan?.lesson_view || 0);
    if (view === 21 || view === 22 || view === 33) return "testDay";

    const ltasks = Array.isArray(plan?.ltasks) ? plan.ltasks : [];
    const materials = Array.isArray(plan?.materials) ? plan.materials : [];
    const tests = Array.isArray(plan?.tests) ? plan.tests : [];

    if (ltasks.length) {
      result = 8;
      for (let j = 0; j < ltasks.length; j += 1) {
        const task = ltasks[j];
        const st = Number(task?.results?.[0]?.status ?? 0);
        if (st < result) result = st;
      }
    } else if (materials.length || tests.length) {
      result = 0;
    } else if (result === 8) {
      result = -1;
    }
  }

  if (result === 0 || result === 3) return "redWarning";
  if (result === 1 || result === 4 || result === 5 || result === 6)
    return "yellowWarning";
  if (result === 2) return "greenWarning";
  return "";
}

function isLessonNavigable(lesson) {
  if (getLessonClass(lesson) === "testDay") return true;
  if (!lesson || !Array.isArray(lesson.lplans) || !lesson.lplans.length) return false;
  return lesson.lplans.some((plan) => {
    const materials = Array.isArray(plan?.materials) ? plan.materials : [];
    const tests = Array.isArray(plan?.tests) ? plan.tests : [];
    const tasks = Array.isArray(plan?.ltasks) ? plan.ltasks : [];
    return materials.length > 0 || tests.length > 0 || tasks.length > 0;
  });
}

function onLessonClick(lesson) {
  if (!isLessonNavigable(lesson)) return;
  emit("open-lesson", lesson);
}

function withIcon(icon, htmlText) {
  return `<span class="material-icons mr-2 f-18 schedule-icon-green">${icon}</span><span>${String(
    htmlText || ""
  )}</span>`;
}

function isDeadlineVisible(deadline) {
  const status = Number(deadline?.status ?? 0);
  return [0, 3, 6].includes(status) && Boolean(deadline?.endDate);
}

function deadlineState(endDate) {
  const ts = new Date(endDate).getTime();
  if (!Number.isFinite(ts)) {
    return {
      active: false,
      text: t("timeEndPassTask"),
      time: "",
      color: "pink-color",
      borderClass: "border-pink-light",
    };
  }

  const diff = ts - Date.now();
  if (diff <= 0) {
    return {
      active: false,
      text: t("timeEndPassTask"),
      time: "",
      color: "pink-color",
      borderClass: "border-pink-light",
    };
  }

  const hours = Math.floor(diff / (60 * 60 * 1000));
  const minutes = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));

  if (hours < 24) {
    const hh = String(Math.max(hours, 0)).padStart(2, "0");
    const mm = String(Math.max(minutes, 0)).padStart(2, "0");
    return {
      active: true,
      text: t("timeToSendTask"),
      time: `${hh}:${mm}`,
      color: hours < 1 ? "pink-color" : "orange-color",
      borderClass: hours < 1 ? "border-pink-light" : "border-orange-light",
    };
  }

  return {
    active: true,
    text: t("sendTask"),
    time: new Date(ts).toLocaleDateString(
      localStorage.getItem("translation") === "kz" ? "kk-KZ" : "ru-RU",
      { day: "numeric", month: "long" }
    ),
    color: "blue-color",
    borderClass: "border-blue-light",
  };
}

function deadlineColor(endDate) {
  return deadlineState(endDate).color;
}

const badge = badgeIcon;
const trophy = trophyIcon;
</script>

<style scoped>
.schedule-day {
  padding: 0 0 12px;
}

.schedule-type {
  display: flex;
  justify-content: flex-end;
  gap: 0;
  padding: 0 12px 8px 12px;
}

.change_class_icon {
  width: 44px;
  height: 44px;
  border-radius: 50px !important;
  background: #36b453 !important;
  color: #fff !important;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 2 !important;
  margin-right: 20px !important;
}

.change_class_icon.hidden {
  display: none;
}

@media screen and (max-width: 768px) {
  .schedule-type {
    position: fixed;
    width: 100%;
    justify-content: flex-end;
    bottom: 70px;
    z-index: 100;
    right: 0;
    padding-right: 14px;
  }
}

.day-schedule {
  margin-top: 10px;
  padding: 0 12px;
}

.lesson {
  color: #678898;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding-top: 8px;
  background: #fff;
}

.item {
  display: flex;
  gap: 0;
}
.lesson__text span p {
  margin-bottom: 0px !important;
}

.big-number {
  width: 24px;
  min-width: 24px;
  color: #36b453;
  font-weight: bold;
  font-size: 20px;
  margin-top: 8px;
  line-height: 1em;
  font-style: normal;
}

.lessons__name {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding-left: 4px;
}

.lesson-subject {
  margin-bottom: 8px;
}

.lesson-subject:last-child {
  margin-bottom: 0;
}

.lesson-subject__title {
  color: #29363d;
  font-size: 17px;
  line-height: 1.25;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.clock-lesson {
  margin-left: 1px;
  margin-top: 4px;
  color: #4f4f4f;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.clock-lesson .fa-clock {
  font-size: 14px !important;
}

.lesson__time {
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  font-family: Roboto, sans-serif;
}

.lesson-marks {
  margin-left: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px;
  font-size: 21px;
}

.mark__body {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  color: #4f4f4f;
}

.mark__body img {
  width: 14px;
  height: 14px;
}

.green {
  color: #0d8740 !important;
}

.yellow {
  color: #9bca16 !important;
}

.orange {
  color: #f2c94c !important;
}

.red {
  color: #eb5757 !important;
}

.grey {
  color: #bdbdbd !important;
}

.defaultDay {
  border: 2px solid #fff;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 4px;
}

.lesson-subject--clickable {
  cursor: pointer;
}

.redWarning {
  border: 2px solid #4db7fe !important;
  background: #edf8ff !important;
}

.yellowWarning {
  border: 2px solid #f2c94c !important;
  background: #fff8d9 !important;
}

.greenWarning {
  border: 2px solid #36b453 !important;
  background: #ebf7ee !important;
}

.testDay {
  border: 2px solid #e46ea2 !important;
  background: #fdeff5 !important;
}

.lesson__text {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  color: #4f4f4f;
  margin-top: 2px;
  line-height: 1.35;
}

.comment__body {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #4f4f4f;
}

.comment__icons {
  color: #2d9cdb;
  font-size: 14px;
  margin-right: 0.5rem !important;
}

.text-purple {
  color: #8265b0;
}

.text-pink {
  color: #ff5d8a;
}

.text-green {
  color: #36b453;
}

:deep(.schedule-icon-green) {
  color: #36b453 !important;
  font-size: 1.125rem !important; /* f-18 in legacy */
  margin-right: 0.5rem !important; /* mr-2 in legacy */
  line-height: 1;
}

.schedule-plan-icon {
  font-size: 1.125rem !important; /* f-18 in legacy */
  margin-right: 0.5rem !important; /* mr-2 in legacy */
  line-height: 1;
}

.duty {
  margin-left: 6px;
  font-style: italic;
}

.resttime {
  position: relative;
  font-size: 12px;
  text-align: center;
  margin: 8px 0;
  padding: 0;
  color: #36b453;
}

.resttime span {
  background: #fff;
  padding: 0 8px;
  position: relative;
  z-index: 1;
}

.resttime:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  border-top: 1px dashed #36b453;
  z-index: 1 !important;
}

.endDateClass {
  font-size: 14px;
  margin-top: 4px;
}

.circuleEndDate {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 8px !important;
  width: 24px;
  min-width: 24px;
  margin-right: 7px;
}

.deadline-time {
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  line-height: 1;
}

.pink-color {
  color: #eb5757;
}

.orange-color {
  color: #f2994a;
}

.blue-color {
  color: #4db7fe;
}

.border-pink-light {
  border: 1px solid #f5b5c6;
}

.border-orange-light {
  border: 1px solid #f9d5a7;
}

.border-blue-light {
  border: 1px solid #9fd7fb;
}

@media screen and (min-width: 768px) {
  .schedule-type {
    height: 72px;
    align-items: center;
    padding: 0 36px 8px;
  }

  .day-schedule {
    padding: 0 36px;
  }
}
</style>
